import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default function Onboarding({ user }) {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({bio:'',city:'',state:'',postcode:'',country:'',address:'',skills:[],availability:'weekends'});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const skills = ['Driving','Cooking','Childcare','Elder Care','Medical','Teaching','Repairs','Gardening','Shopping','Tech Help','Language','Counseling'];

  const toggleSkill = (s) => {
    setForm(f => ({...f, skills: f.skills.includes(s) ? f.skills.filter(x=>x!==s) : [...f.skills, s]}));
  };

  const handleSubmit = async () => {
    setLoading(true);
    await updateDoc(doc(db, 'users', user.uid), {
      bio: form.bio, city: form.city, state: form.state,
      postcode: form.postcode, country: form.country,
      address: form.address, skills: form.skills,
      availability: form.availability, onboarded: true,
    });
    navigate('/dashboard');
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#F0FDF4,#FEF9C3)',display:'flex',alignItems:'center',justifyContent:'center',padding:'1rem'}}>
      <div className="card" style={{width:'100%',maxWidth:'560px'}}>
        <div style={{marginBottom:'2rem'}}>
          <div style={{display:'flex',gap:'8px',marginBottom:'1.5rem'}}>
            {[1,2,3].map(i=>(
              <div key={i} style={{flex:1,height:'6px',borderRadius:'3px',background:step>=i?'#16A34A':'#E5E7EB',transition:'background .3s'}}/>
            ))}
          </div>
          <h2 style={{fontSize:'22px',fontWeight:800,marginBottom:'4px'}}>
            {step===1?'📍 Your Location':step===2?'👤 About You':'✅ Almost Done!'}
          </h2>
          <p style={{fontSize:'14px',color:'#6B7280'}}>Step {step} of 3</p>
        </div>

        {step===1 && (
          <div>
            <div className="form-group"><label>Country</label><input value={form.country} onChange={e=>setForm({...form,country:e.target.value})} placeholder="e.g. Malaysia"/></div>
            <div className="form-group"><label>State / Province</label><input value={form.state} onChange={e=>setForm({...form,state:e.target.value})} placeholder="e.g. Selangor"/></div>
            <div className="form-group"><label>City</label><input value={form.city} onChange={e=>setForm({...form,city:e.target.value})} placeholder="e.g. Petaling Jaya"/></div>
            <div className="form-group"><label>Postcode</label><input value={form.postcode} onChange={e=>setForm({...form,postcode:e.target.value})} placeholder="e.g. 47810"/></div>
            <div className="form-group"><label>Street Address</label><input value={form.address} onChange={e=>setForm({...form,address:e.target.value})} placeholder="e.g. No 12, Jalan SS2/24"/></div>
            <button className="btn btn-primary" style={{width:'100%',justifyContent:'center',padding:'12px'}} onClick={()=>setStep(2)}>Next →</button>
          </div>
        )}

        {step===2 && (
          <div>
            <div className="form-group"><label>Bio</label><textarea rows={3} value={form.bio} onChange={e=>setForm({...form,bio:e.target.value})} placeholder="Tell the community about yourself..."/></div>
            <div className="form-group">
              <label>Your Skills (select all that apply)</label>
              <div style={{display:'flex',flexWrap:'wrap',gap:'8px',marginTop:'8px'}}>
                {skills.map(s=>(
                  <div key={s} onClick={()=>toggleSkill(s)} style={{padding:'6px 14px',borderRadius:'20px',cursor:'pointer',border:`2px solid ${form.skills.includes(s)?'#16A34A':'#D1D5DB'}`,background:form.skills.includes(s)?'#DCFCE7':'white',fontSize:'13px',fontWeight:500,transition:'all .2s'}}>
                    {s}
                  </div>
                ))}
              </div>
            </div>
            <div className="form-group">
              <label>Availability</label>
              <select value={form.availability} onChange={e=>setForm({...form,availability:e.target.value})}>
                <option value="anytime">Anytime</option>
                <option value="weekdays">Weekdays only</option>
                <option value="weekends">Weekends only</option>
                <option value="evenings">Evenings only</option>
                <option value="flexible">Flexible</option>
              </select>
            </div>
            <div style={{display:'flex',gap:'8px'}}>
              <button className="btn btn-gray" style={{flex:1,justifyContent:'center'}} onClick={()=>setStep(1)}>← Back</button>
              <button className="btn btn-primary" style={{flex:2,justifyContent:'center',padding:'12px'}} onClick={()=>setStep(3)}>Next →</button>
            </div>
          </div>
        )}

        {step===3 && (
          <div style={{textAlign:'center'}}>
            <div style={{fontSize:'64px',marginBottom:'1rem'}}>🎉</div>
            <h3 style={{fontSize:'20px',fontWeight:800,marginBottom:'8px'}}>You're all set!</h3>
            <p style={{color:'#6B7280',fontSize:'14px',marginBottom:'1.5rem',lineHeight:1.6}}>Your profile is being reviewed by our admin team. You'll be notified once approved. In the meantime, explore the platform!</p>
            <div className="alert alert-orange" style={{textAlign:'left',marginBottom:'1.5rem'}}>
              <strong>📋 Pending Verification</strong><br/>
              <span style={{fontSize:'13px'}}>Please upload your ID card and address proof in your profile to speed up approval.</span>
            </div>
            <button className="btn btn-primary" style={{width:'100%',justifyContent:'center',padding:'12px',fontSize:'15px'}} onClick={handleSubmit} disabled={loading}>
              {loading ? 'Saving...' : '🏘 Go to Dashboard'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
